export default __webpack_public_path__ + "static/3-fc85f741608c0d7c5cbbc7f3d3bdf2dd.jpg";